import { Center, Flex, Spinner, Text, Dialog, Portal } from "@chakra-ui/react";

export default function LoginModal() {
    return (
        <Dialog.Root open={true} size="xs" placement="center">
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Body>
                            <Center>
                                <Flex direction="column" align="center" py={8}>
                                    <Spinner thickness="3px" speed="0.45s" emptyColor="gray.200" color="color1" size="lg" />
                                    <Text color="#999">Checking user access...</Text>
                                </Flex>
                            </Center>
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
}
